const state = () => ({
  active: false,
  verified: false,
  pendingSetup: false
})

const getters = {}

const actions = {
  async checkNS ({rootState}, payload) {
    const {data} = await axios.get(`https://new-api.estage.com/api/projects/${rootState.projects.project.id}/domain-ns`)
    const validNSGroups = [
      ['kiki.bunny.net', 'coco.bunny.net'],
      ['ns1.estage.site', 'ns2.estage.site'],
      payload
    ].filter(Boolean)

    const isValid = validNSGroups.some(group =>
      group.every(ns => data.data.ns.includes(`${ns}.`))
    )

    let awsValid = false
    if (payload?.length) {
      awsValid = payload.every(ns => data.data.ns.includes(`${ns}.`))
    }

    this.verified = isValid
    this.pendingSetup = data.data.setup
    return {
      valid: isValid,
      awsValid,
      pending: data.data.setup
    }
  },
  async setupDomain ({rootState}) {
    return await axios.get(`api/projects/${rootState.projects.project.id}/bunny-setup`)
  },
  async fetchDNS ({rootState}) {
    const {data} = await axios.get(`api/projects/${rootState.projects.project.id}/bunny-dns`)
    return data.data
  },
  async fetchCountries ({rootState}) {
    const {data} = await axios.get(`api/projects/${rootState.projects.project.id}/bunny-countries`)
    return data.data
  },
  async fetchBlockedCountries ({rootState}) {
    const {data} = await axios.get(`api/projects/${rootState.projects.project.id}/bunny-traffic-manager`)
    return data.data
  },
  async blockCountries ({rootState}, payload) {
    return await axios.post(`api/projects/${rootState.projects.project.id}/bunny-traffic-manager`, payload)
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}